import { ExperienceOption } from '@/types'
import React, { useMemo } from 'react'
import { useTranslation } from 'next-i18next'
import { Clock } from 'lucide-react'

const ExperienceDuration = ({ option }: { option?: ExperienceOption }) => {
  const { t } = useTranslation('experience')

  const duration = useMemo(() => {
    const times = []

    if (!option) {
      return null
    }

    if (option.days > 0) {
      times.push(t('days', { count: option.days }))
    }

    if (option.hours > 0) {
      times.push(t('hours', { count: option.hours }))
    }

    if (option.minutes > 0) {
      times.push(t('minutes', { count: option.minutes }))
    }

    return times.join(', ')
  }, [option, t])

  return (
    <div className="flex space-x-1 items-center text-sm">
      <Clock size={12} /> <span>{duration}</span>
    </div>
  )
}

export default ExperienceDuration
